import React, { StatelessComponent } from 'react';

import EventItemHorizontalStub from '@components/event-item/event-item-horizontal.stub';
import EventItemVerticalStub from '@components/event-item/event-item-vertical.stub';

interface Props {
    type: 'horizontal' | 'vertical';
}

const EventItemStub: StatelessComponent<Props> = ({ type }) => {
    const TypedStub = (type === 'horizontal') ? EventItemHorizontalStub : EventItemVerticalStub;

    return <TypedStub />;
};

export default EventItemStub;
